import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

import { SignupReactUFO } from './signup-react-ufo-experience';
import { SignupUFOExperience } from './signup-ufo-logging';
import { UfoCustomTimingKey } from './ufo.types';

/**
 * Account Signin
 */
export const ufoEventAccountSignin = new SignupUFOExperience('bxpui.account-signin.slo', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
	customTimingKeys: [UfoCustomTimingKey.IDENTITY_USER_SIGNUP_API],
	platform: {
		component: `signin`,
	},
});

/**
 * Land Step — Account Creation
 * Tome SLOs: https://tome.prod.atl-paas.net/capability/2b3257ff-3fcb-4bab-ad4a-21addc51da91
 **/
export const ufoEventAccountCreation = new SignupUFOExperience('bxpui.account-creation.slo', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
	customTimingKeys: [UfoCustomTimingKey.IDENTITY_USER_SIGNUP_API],
});
export const ufoEventLegacyAccountCreation = new SignupUFOExperience(
	'bxpkit.account-creation.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		customTimingKeys: [UfoCustomTimingKey.IDENTITY_USER_SIGNUP_API],
	},
);
/**
 * Land Step — Site Creation & Product Activation
 * Tome SLOs: https://tome.prod.atl-paas.net/capability/5eb87129-93bf-4299-bb87-647274daab95
 **/
export const ufoEventNewSiteN2NSubmit = new SignupUFOExperience('bxpui.new-site-n2n-submit.slo', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
});
export const ufoEventGetSitesN2E = new SignupUFOExperience('bxpui.get-sites-n2e.slo', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
});
export const ufoEventGetUser = new SignupUFOExperience('bxpui.get-user.slo', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
});
export const ufoEventExistingSiteN2ESubmit = new SignupUFOExperience(
	'bxpui.existing-site-n2e-submit.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
export const ufoEventLegacyNewSiteN2NSubmit = new SignupUFOExperience(
	'bxpkit.new-site-n2n-submit.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
export const ufoEventLegacyNewSiteN2NPaidSubmit = new SignupUFOExperience(
	'bxpkit.new-site-n2n-paid-submit.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
export const ufoEventLegacyExistingSiteN2ESubmit = new SignupUFOExperience(
	'bxpkit.existing-site-n2e-submit.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
export const ufoEventLegacyExistingSiteN2EPaidSubmit = new SignupUFOExperience(
	'bxpkit.existing-site-n2e-paid-submit.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

/**
 * Land Step — Company Expand (Join Org Products)
 * Tome SLOs: https://tome.prod.atl-paas.net/capability/60eca846-999d-4a1e-a77c-afbd53bfe0ee
 **/
export const ufoEventGetUserProfile = new SignupUFOExperience('get-user-profile.slo', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
});

export const ufoEventCompanyExpandJoinProduct = new SignupUFOExperience(
	'company-expand.join-product.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

export const ufoEventCompanyExpandUserSegmentationAdvice = new SignupUFOExperience(
	'company-expand.user-segmentation-advice.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

export const ufoEventCompanyExpandCreateProject = new SignupUFOExperience(
	'company-expand.create-project.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
/**
 * Land Step — Confirmation Page (Loading State)
 * Tome SLOs: https://tome.prod.atl-paas.net/capability/3b1751df-8961-4b23-a153-cb5d5d97555e
 **/
export const ufoEventConfirmationPageStatusPolling = new SignupUFOExperience(
	'bxpui.confirmation-page-status-polling.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

export const ufoEventConfirmationPageUpdateUserProfile = new SignupUFOExperience(
	'bxpui.confirmation-page-update-user-profile.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

export const ufoEventConfirmationPageTeamTypeSelection = new SignupUFOExperience(
	'bxpui.confirmation-page-team-type-selection.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

export const ufoEventConfirmationPageTemplateSelectionContinue = new SignupUFOExperience(
	'bxpui.confirmation-page-template-selection-continue.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

export const ufoEventConfirmationPageTemplateSelectionBack = new SignupUFOExperience(
	'bxpui.confirmation-page-template-selection-back.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

/**
 * Land Step — GraphQL Webhook for Provisioning Status
 **/
export const ufoEventGraphQLWebhookSetup = new SignupUFOExperience('graphql-webook-setup.slo', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
});
export const ufoEventGraphQLSubscriptionSetup = new SignupUFOExperience(
	'graphql-subscription-setup.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
export const ufoEventGraphQLGetProvisioningStatus = new SignupUFOExperience(
	'graphql-get-provisioning-status.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
/**
 * Land Step — Product Landing
 * Tome SLOs: https://tome.prod.atl-paas.net/capability/94be6943-f4c3-4f5e-9ec3-370dc65bb3af
 **/
export const ufoEventProductSetupLatency = new SignupUFOExperience('bxpui.product-setup-latency', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.Custom,
});

export const ufoEventE2eProvisioningLatency = new SignupUFOExperience(
	'bxpui.e2e-provisioning-latency',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.Custom,
	},
);

export const ufoEventRedirectToProduct = new SignupUFOExperience(
	'bxpui.redirect-to-product-from-confirmation-page.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		customTimingKeys: [
			UfoCustomTimingKey.ACTIVATE_STATUS_CCP_POLLING_API,
			UfoCustomTimingKey.CLOUD_STATUS_HAMS_POLLING_API,
			UfoCustomTimingKey.ROBOTS_VIEW_DWELL_TIME,
			UfoCustomTimingKey.CONFLUENCE_ONBOARDING_STEPS_DWELL_TIME,
			UfoCustomTimingKey.CONFLUENCE_ONBOARDING_SPINNER_DWELL_TIME,
			UfoCustomTimingKey.CONFLUENCE_DEFAULT_CIRCLE_DWELL_TIME,
			UfoCustomTimingKey.JIRA_ANIMATED_PROVISIONING_DWELL_TIME,
			UfoCustomTimingKey.JIRA_ONBOARDING_WIZARD_PROJECT_CREATE_DWELL_TIME,
			UfoCustomTimingKey.JIRA_TEMPLATE_CHOICE_DWELL_TIME,
			UfoCustomTimingKey.JIRA_USER_SEGMENTATION_DWELL_TIME,
			UfoCustomTimingKey.USER_SEGMENTATION_DWELL_TIME,
			UfoCustomTimingKey.TIPS_VIEW_DWELL_TIME,
			UfoCustomTimingKey.GRAPHQL_WEBHOOK_SETUP,
			UfoCustomTimingKey.GRAPHQL_SUBSCRIPTION_ACK,
			UfoCustomTimingKey.GRAPHQL_WEBHOOK_PROVISIONING_LATENCY,
		],
	},
);

export const ufoEventGetJiraSitesFromAgg = new SignupUFOExperience(
	'bxpui.get-jira-sites-from-agg.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

/**
 * Signup Dependency — Google Recaptcha API
 **/
export const ufoEventGetRecaptcha = new SignupUFOExperience('bxpui.get-recaptcha-api.slo', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
});

export const ufoEventTryCloudSignupPageLoad = new SignupUFOExperience('try-cloud-signup.slo', {
	type: ExperienceTypes.Load,
	performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
});
export const ufoEventTryCloudSignupAvailableProducts = new SignupUFOExperience(
	'try-cloud-signup.available-products.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

export const ufoEventTryCloudSignupConsentConfig = new SignupUFOExperience(
	'try-cloud-signup.consent-config.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

export const ufoEventTryCloudSignupExpandFreeValidation = new SignupUFOExperience(
	'try-cloud-signup.expand-free-validation.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

export const ufoEventPaidSignupLandingPageLoad = new UFOExperience(
	'bxpui.paid-signup-page-load.slo',
	{
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	},
);

export const ufoEventPaidSignupJSWLandingPageLoad = new SignupUFOExperience(
	'bxpui.paid-signup-page-load-jsw.slo',
	{
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	},
);

export const ufoEventPaidSignupConfluenceLandingPageLoad = new SignupUFOExperience(
	'bxpui.paid-signup-page-load-confluence.slo',
	{
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	},
);

export const ufoEventPaidSignupJSMLandingPageLoad = new SignupUFOExperience(
	'bxpui.paid-signup-page-load-jsm.slo',
	{
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	},
);

export const ufoEventBxpGatewayAnchorParse = new SignupUFOExperience(
	'bxpui.bxp-gateway-anchor-parse',
	{
		type: ExperienceTypes.Operation,
		performanceType: ExperiencePerformanceTypes.Custom,
	},
);

export const ufoEventSignupFormLoad = new SignupUFOExperience('bxpui.signup-form-load.slo', {
	type: ExperienceTypes.Load,
	performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	customTimingKeys: [
		UfoCustomTimingKey.STARGATE_AVAILABLE_PRODUCTS_API,
		UfoCustomTimingKey.STARGATE_USER_API,
	],
});

export const ufoEventSiteNameFormLoad = new SignupUFOExperience('bxpui.site-name-form-load.slo', {
	type: ExperienceTypes.Load,
	performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	customTimingKeys: [UfoCustomTimingKey.STARGATE_AVAILABLE_PRODUCTS_API],
});

export const ufoEventSiteNameAvailability = new SignupUFOExperience(
	'bxpui.site-name-availability.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

/**
 * Buy cloud post order provisioning page
 **/
export const ufoEventPostOrderGetActivationType = new SignupReactUFO(
	'post-order.get-activation-type.slo',
);

export const ufoEventPostOrderExistingSiteActivation = new SignupReactUFO(
	'post-order.existing-site-activation.slo',
);

export const ufoEventPostOrderNewSiteActivation = new SignupReactUFO(
	'post-order.new-site-activation.slo',
);

export const ufoEventPostOrderOrgActivation = new SignupReactUFO('post-order.org-activation.slo');

export const ufoEventPostOrderAccountOrgList = new SignupReactUFO(
	'post-order.account-org-list.slo',
);

export const ufoEventPostOrderAccountOrgListNextPage = new SignupReactUFO(
	'post-order.account-org-list-next-page.slo',
);

export const ufoEventProvisioningStatusCloudIdAvailability = new SignupUFOExperience(
	'provisioning-status-cloud-id-availability.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

/**
 * Onboarding wizard project creation
 **/
export const ufoEventOnboardingWizardProjectCreation = new SignupUFOExperience(
	'onboarding-wizard.project-create',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

/**
 * Onboarding wizard project creation including provisioning
 **/
export const ufoEventOnboardingWizardProjectCreationIncludingProvisioning = new SignupUFOExperience(
	'onboarding-wizard.project-create-including-provisioning',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		customTimingKeys: [UfoCustomTimingKey.ONBOARDING_WIZARD_PROJECT_CREATE_API_CALL],
	},
);

/**
 * Async Architecture
 */
export const ufoEventAsyncArchitectureNewSiteActivation = new SignupUFOExperience(
	'async-architecture.new-site-activation',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
export const ufoEventAsyncArchitecturePollingStatus = new SignupUFOExperience(
	'async-architecture.polling-status',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

/**
 * Autoselect theme preference
 **/
export const ufoEventOnboardingAutoSelectThemePreference = new SignupUFOExperience(
	'onboarding.auto-select-theme-preference',
	{
		type: ExperienceTypes.Operation,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

/**
 * Resolve tenant Id during onboaring
 **/
export const ufoEventOnboardingResolveTenantId = new SignupUFOExperience(
	'onboarding.resolve-tenant-id',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		customTimingKeys: [UfoCustomTimingKey.RESOLVE_TENANT_ID],
	},
);

/**
 * Inviting users
 **/
export const ufoEventOnboardingInviteUsers = new SignupUFOExperience(
	'onboarding.invite-users-step',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		customTimingKeys: [
			UfoCustomTimingKey.JIRA_ONBOARDING_WIZARD_INVITE_POLLING_PROJECT_CREATE_TASK,
			UfoCustomTimingKey.JIRA_ONBOARDING_WIZARD_INVITE_FETCHING_ROLES,
			UfoCustomTimingKey.JIRA_ONBOARDING_WIZARD_INVITE_INVITING_USERS,
			UfoCustomTimingKey.JIRA_ONBOARDING_WIZARD_INVITE_CHECKING_LICENSE,
		],
	},
);

/**
 * Madlib project creation
 */
export const ufoEventMadlibProjectCreation = new SignupUFOExperience(
	'onboarding.madlib-project-create',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		customTimingKeys: [UfoCustomTimingKey.JIRA_ONBOARDING_MADLIB_PROJECT_CREATE],
	},
);

/**
 * Default project creation when Madlib screen is skipped
 */
export const ufoEventSkippedMadlibProjectCreation = new SignupUFOExperience(
	'onboarding.skipped-madlib-project-create',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		customTimingKeys: [UfoCustomTimingKey.JIRA_ONBOARDING_DEFAULT_PROJECT_CREATE],
	},
);

/**
 * Provisioning funnel — end-to-end timings from tenant resolution to landing in-product
 * Captures: Tenant ID Resolution, Provisioning Success, Project Creation, Invite Teammates, Land in-product after redirection
 */
export const ufoEventProvisioningFunnel = new SignupUFOExperience('percieved-provisioning-funnel', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
	customTimingKeys: [
		UfoCustomTimingKey.PERCEIVED_PROVISIONING_FUNNEL_TENANT_ID_RESOLUTION,
		UfoCustomTimingKey.PERCEIVED_PROVISIONING_FUNNEL_PROVISIONING_SUCCESS,
		UfoCustomTimingKey.PERCEIVED_PROVISIONING_FUNNEL_PROJECT_CREATION_INITIALIZED,
		UfoCustomTimingKey.PERCIEVED_PROVISIONING_FUNNEL_PROJECT_POLLING,
		UfoCustomTimingKey.PERCEIVED_PROVISIONING_FUNNEL_INVITE_TEAMMATES,
	],
});

/**
 * Loom Onboarding — time-to-view
 *
 * Measures wall-clock time from the moment the WAC confirmation page mounts
 * for the LOOM product (i.e. the user just landed here from IDAC and cloud
 * status polling / provisioning is kicking off) until user reaches onboarding.
 *
 * isExpOnboardingWac (`exp-loom-onboarding-on-wac`) will change when the user
 * reaches onboarding because it places onboarding _during_ provisioning.
 *
 * UFO already records the total experience duration between `start()` and
 * `success()`, so no substep is needed here.
 */
export const ufoEventLoomOnboardingTimeToView = new SignupUFOExperience(
	'bxpui.loom-onboarding-time-to-view.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: {
			component: 'loom-onboarding',
		},
	},
);

/**
 * Loom Onboarding — flow duration (experiment variant only)
 *
 * Measures wall-clock time from the moment the first loom onboarding step becomes
 * visible (StepManager renders step 0) until the user reaches
 * `AfterOnboardingStep`. Emitted on `success()` with a `hasProvisioningTimeLeft`
 * boolean so we can slice "finished onboarding before provisioning did" vs
 * "provisioning already resolved when they got there".
 *
 * Only ever fires for the experiment variant — control users never render
 * `StepManager` with steps.
 */
export const ufoEventLoomOnboardingFlowDuration = new SignupUFOExperience(
	'bxpui.loom-onboarding-flow-duration.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: {
			component: 'loom-onboarding',
		},
	},
);

/**
 * Loom Provisioning — total duration (experiment-agnostic)
 *
 * Measures wall-clock time from confirmation-page mount (post-IDAC redirect,
 * when cloud status polling begins) until the browser is handed off to Loom
 * via `window.location.assign`. Fires for both control and variant users, so
 * we can compare end-to-end "user landed → user left for Loom" time across
 * the experiment.
 */
export const ufoEventLoomProvisioningDuration = new SignupUFOExperience(
	'bxpui.loom-provisioning-duration.slo',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: {
			component: 'loom-onboarding',
		},
	},
);
